module.exports = __webpack_public_path__ + "static/media/stat547u_lecture06.ab3e5fcd.pdf";